





























































































































import { defineComponent } from "@vue/composition-api";
import NumberFormatter from "@/services/number.formatter";
import { Interval, createNewDefaultInterval } from "@/models/Interval";
import { BlockLabel } from "@/models/BlockLabel";
import {
  Expandable,
  BlockContainer,
  Checkbox,
  TextField,
} from "@/components";

export default defineComponent({
  name: "PricePerUnit",
  components: {
    Expandable,
    BlockContainer,
    Checkbox,
    TextField,
  },
  props: {
    initialLimit: { type: Number, default: 0 },
    blockId: {
      type: Number,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    data: { type: Object, default: null },
    initialUnitPrice: { type: Number, default: null },
  },
  data() {
    return {
      startsAt: this.initialLimit || 0,
      displayName: BlockLabel.PricePerUnit,
      intervals: Array<Interval>(),
      infiniteUpperLimit: false,
      unitPrice: this.initialUnitPrice || 0,
    };
  },
  computed: {},
  mounted() {
    if (this.data) {
      this.startsAt = this.data.startsAt;
      this.intervals = this.data.intervals;
      this.infiniteUpperLimit = this.data.infiniteUpperLimit;
      this.unitPrice = this.data.unitPrice;
    } else {
      this.addInterval();
    }
  },
  methods: {
    addInterval(): void {
      var newInterval = createNewDefaultInterval(this.intervals, {
        startsAt: this.startsAt,
        defaultAmount: 1000,
      });
      this.intervals.push(newInterval);
    },
    isUnitPriceValid(): boolean {
      return this.unitPrice !== null && this.unitPrice > 0;
    },
    getUnitPriceLabel(): string {
      return this.isUnitPriceValid() ? `kr ${this.unitPrice} per` : "ugyldig";
    },
    removeInterval(): void {
      this.intervals.pop();
    },
    expandBlock() {
      this.$emit("setBlockExpanded", this.blockId);
    },
    collapseBlock(): void {
      this.$emit("updateBlock", {
        blockId: this.blockId,
        type: this.$options.name,
        intervals: this.intervals,
        startsAt: this.startsAt,
        infiniteUpperLimit: this.infiniteUpperLimit,
        unitPrice: this.isUnitPriceValid() ? this.unitPrice : 0,
      });
      this.$emit(
        "highestIntervalValue",
        this.intervals[this.intervals.length - 1].upperLimit
      );
    },
    getLowerLimit(index: number): number {
      if (index == 0) return this.startsAt;

      return this.intervals[index - 1].upperLimit;
    },
    getNewColor(index: number): string {
      var colors = ["#39CCCC", "#FF9186", "#B4DA55", "#B5649b"];

      index = index % colors.length;

      return colors[index];
    },
    shortenedNumber(number: number): string {
      return NumberFormatter.shortForm(number, 3);
    },
    asCurrency(number: number): string {
      return `${NumberFormatter.withThousandsSeparator(number, " ")}`;
    },
    isLast(list: Array<any>, index: number): boolean {
      return index + 1 == list.length;
    },
  },
});
